<template src="./template.html"></template>
<script>
import { mapState } from 'vuex'

import store from 'src/store'
import * as mutationTypes from 'store/mutationTypes'

export default {
  name: 'chat-app-home',
  computed: {
    ...mapState({
      date: (state) => state.date.current,
      venue: (state) => state.venue.current,
      user: (state) => state.user.current,
    }),
  },
  data() {
    return {
      loading: true,
    }
  },
  methods: {
    onMutation(mutation) {
      if (mutation.type === mutationTypes.SHOW_CHAT_APP) {
        // this.scrollCustomerChat();
      }
    },
  },
  created() {
    this.storeUnsubscribe = store.subscribe(this.onMutation)

    this.loading = true

    const promises = []

    Promise.all(promises)
      .then(() => {
        this.loading = false
      })
      .catch(() => {
        this.loading = false
      })
  },
  destroyed() {
    if (this.storeUnsubscribe) this.storeUnsubscribe()
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Widgets/Chat/ChatAppHome/index.vue